module.exports = __webpack_public_path__ + "img/MDA.d0ac3a31.svg";